import React from 'react';
import { Database, ShieldCheck } from 'lucide-react';
import { Card } from '../../../shared/components/ui/Card';

interface HealthStatusProps {
    showTutorial: boolean;
}

const HealthStatus = ({ showTutorial }: HealthStatusProps) => {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Data Intelligence Insight */}
            <Card
                className="p-6 relative overflow-hidden group"
                showTutorial={showTutorial}
                tutorial="Puntos de datos externos extra (clima, eventos) procesados hoy para tomar decisiones más inteligentes por ti."
            >
                <div className="absolute -right-8 -top-8 bg-blue-100/30 w-48 h-48 rounded-full blur-3xl group-hover:bg-blue-100/50 transition-all duration-1000"></div>

                <div className="flex items-start gap-4 mb-6 relative z-10">
                    <div className="p-3 bg-blue-50 rounded-xl text-blue-500 border border-blue-100 shadow-sm">
                        <Database size={28} />
                    </div>
                    <div>
                        <div className="flex items-center gap-2 flex-wrap">
                            <h3 className="text-slate-900 font-bold text-lg">Inteligencia de datos</h3>
                            <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">Ejemplo</span>
                        </div>
                        <p className="text-xs text-slate-500 font-medium uppercase tracking-wider">Capa de enriquecimiento</p>
                    </div>
                </div>

                <div className="relative z-10">
                    <div className="flex items-baseline gap-2 mb-3">
                        <span className="text-4xl font-bold text-slate-900">52.400</span>
                        <span className="text-sm text-blue-600 font-semibold bg-blue-50 px-2 py-1 rounded-full text-[10px] uppercase tracking-wide">Comportamientos detectados</span>
                    </div>

                    <p className="text-slate-600 leading-relaxed text-sm border-l-2 border-blue-200 pl-4 py-1">
                        Procesados hoy <span className="text-slate-900 font-semibold">además de tu base de datos</span>. Cruzamos clima local, eventos cercanos y patrones de comportamiento para anticipar lo que va a comprar tu cliente.
                    </p>
                </div>
            </Card>

            {/* WhatsApp Health */}
            <Card
                className="p-6 flex flex-col relative overflow-hidden bg-gradient-to-br from-white to-green-50/30"
                showTutorial={showTutorial}
                tutorial="Puntaje de seguridad de la cuenta. 'Estable' significa que los mensajes se envían a un ritmo seguro para evitar bloqueos."
            >
                <div className="absolute -left-8 -bottom-8 bg-green-100/40 w-48 h-48 rounded-full blur-3xl"></div>

                <div className="flex items-center justify-between mb-6 relative z-10">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-green-100/50 rounded-lg text-green-700">
                            <ShieldCheck size={24} />
                        </div>
                        <h3 className="text-slate-900 font-semibold">Salud de WhatsApp</h3>
                        <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-amber-100 text-amber-700">Ejemplo</span>
                    </div>
                    <div className="px-3 py-1 bg-green-100 rounded-full border border-green-200 text-green-700 text-xs font-bold uppercase tracking-wider flex items-center gap-2">
                        <div className='w-2 h-2 rounded-full bg-green-500 animate-pulse'></div>
                        Estable
                    </div>
                </div>

                <div className="flex-1 flex items-center justify-between gap-8 relative z-10 px-4">
                    <div className="relative w-28 h-28 flex items-center justify-center flex-shrink-0">
                        {/* Circular Progress Mockup */}
                        <svg className="w-full h-full -rotate-90 drop-shadow-xl" viewBox="0 0 100 100">
                            <circle cx="50" cy="50" r="45" fill="none" stroke="#f1f5f9" strokeWidth="8" />
                            <circle cx="50" cy="50" r="45" fill="none" stroke="#22c55e" strokeWidth="8" strokeDasharray="283" strokeDashoffset="10" strokeLinecap="round" />
                        </svg>
                        <div className="absolute inset-0 flex flex-col items-center justify-center">
                            <span className="text-3xl font-bold text-slate-900">98%</span>
                        </div>
                    </div>

                    <div className="flex flex-col gap-3 text-sm w-full">
                        <div className="flex justify-between border-b border-slate-100 pb-2">
                            <span className="text-slate-500 font-medium">Riesgo de Bloqueo</span>
                            <span className="text-green-600 font-mono font-bold">0.2% (Bajo)</span>
                        </div>
                        <div className="flex justify-between border-b border-slate-100 pb-2">
                            <span className="text-slate-500 font-medium">Ritmo de Mensajes</span>
                            <span className="text-slate-900 font-mono font-bold">12/min</span>
                        </div>
                        <p className="text-xs text-slate-400 mt-1 italic">
                            Cuenta saludable. Ritmo optimizado.
                        </p>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default HealthStatus;
